import React, {useState, useEffect} from 'react';
import {SelectArrayInput, Loading, Error} from 'react-admin';
import getDirectory from "../staticDirectoryCache";

const DictionarySelectArrayInput = ({dirname, ...props}) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    useEffect(() => {
        getDirectory(dirname)
            .then((data) => {
                setOptions(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            })
    }, [dirname]);

    if (loading) return <Loading/>;
    if (error) return <Error/>;
    if (!options) return null;

    return (
        <SelectArrayInput
            choices={options}
            {...props}
        />
    );
};

export default DictionarySelectArrayInput;